var map = {
	"./awardsdescription.jpg": "dc229",
	"./searching.jpg": "dd52",
	"./selectingawards.jpg": "ff0b",
	"./shadowbox.jpg": "f5ab",
	"./shadowboxbuilder.jpg": "8171",
	"./veteranstory.jpg": "0487"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0cf7";